export const nameToVarint: Record<string, Uint8Array> = {
  'flv-ddoc': Uint8Array.from([1]),
};
export const constantToCode: Record<string, number> = {
  FLV_DDOC: 1,
};
export const codeToName: Record<number, string> = {
  1: 'flv-ddoc',
};
